import React from 'react';
import Browse from './Browse';

const Apps = props => <Browse pageType="apps" {...props} />;

export default Apps;
